import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SummaryApi from "../common";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import NoImage from "../asset/noimage.png";
import { FaTag, FaVideo } from "react-icons/fa";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const decodedId = atob(id); // Base64 decode
useEffect(() => {
  window.scrollTo(0, 0);
}, []);
const navigate = useNavigate();

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await fetch(SummaryApi.getBlogDetailsbyId.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ blog_id: decodedId }),
        });

        const result = await res.json();
        if (res.ok && result.status) {
          setBlog(result.data);
        } else {
          console.error("Error fetching blog details:", result);
        }
      } catch (err) {
        console.error("Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [decodedId]);

  const getFullMediaUrl = (path) => {
    if (!path) return NoImage;
    const base = SummaryApi.Images.url.replace("/api", "");
    return `${base}/${path.replace(/\\/g, "/")}`;
  };

  if (loading)
    return <p className="text-center py-10 text-gray-500">Loading blog...</p>;

  if (!blog)
    return <p className="text-center text-red-500 py-10">Blog not found.</p>;

  return (
    <div>

    <div className="block md:hidden mb-4">

<button
  onClick={() => navigate(-1)}
  className="fixed top-18 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white dark:bg-gray-800 rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:border-gray-700 lg:hidden"
>
  <FaArrowLeft className="text-black dark:text-white" />
</button>
</div>
  <section className="p-4 md:p-10 max-w-7xl mx-auto bg-white dark:bg-[#111827] shadow-md md:rounded-xl md:my-5">

  {/* Title */}
  <h1 className="text-4xl font-extrabold text-blue-900 dark:text-blue-400 mb-2">
    {blog.title}
  </h1>

  {/* Subtitle */}
  {blog.subtitle && (
    <p className="text-lg text-gray-600 dark:text-gray-300 italic mb-4 border-l-4 pl-4 border-blue-300 dark:border-blue-600">
      {blog.subtitle}
    </p>
  )}

  {/* Category */}
  {blog.category && (
    <div className="flex items-center text-sm text-white bg-orange-500 dark:bg-orange-600 px-3 py-1 w-fit rounded-full mb-6">
      <FaTag className="mr-2" />
      {blog.category}
    </div>
  )}

  {/* Blog Image */}
  <img
    src={getFullMediaUrl(blog.blog_image)}
    alt={blog.title}
    className="w-full max-h-[400px] object-cover rounded-lg mb-8"
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = NoImage;
    }}
  />

  {/* Description */}
  <div className="prose prose-lg max-w-none text-gray-800 dark:text-gray-200 leading-relaxed">
    <p>{blog.description1}</p>
    {blog.description2 && <p className="mt-6">{blog.description2}</p>}
  </div>

  {/* Blog Video (if present) */}
  {blog.blog_video && (
    <div className="mt-10">
      <h3 className="text-2xl font-bold text-blue-800 dark:text-blue-400 mb-4 flex items-center">
        <FaVideo className="mr-2" />
        Blog Video
      </h3>
      <video
        controls
        className="w-full rounded-lg shadow-md"
        src={getFullMediaUrl(blog.blog_video)}
      >
        Your browser does not support the video tag.
      </video>
    </div>
  )}
</section>
</div>
  );
};

export default BlogDetails;
